import React from "react";
import { useState, useEffect } from "react";
import {
  Typography,
  Card,
  CardContent,
  Button,
  CardActions,
  CardHeader,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import "./admin-track-request.css";
import Storage from "../../session/storage";
import api from "../../service/api";
import DateTranslatedPicker from "./datePicker";
import jsondata from "../../config/AdminTrackPageConfig.json";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const FilterOption = (props) => {
  const [maxDate, setMaxDate] = useState("");
  const [minDate, setMinDate] = useState("");
  const [searchData, setSearchData] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [countryList, setCountryList] = useState(Storage.getAllCountryList())


  // fetch user access specific country list if no availble in Storage file
  useEffect(() => {
    if (countryList === null || countryList === undefined) {
      async function fetchDetails() {
        await api.getSelectedDCRCountry().then((countryList) => {
          var countryListData = countryList.data
          Storage.setAllCountryList(countryList.data)
          setCountryList(countryListData.map(item => item.split('#')[0]))

        }).catch((error) => {
        })
      }

      fetchDetails();
    }
    countryList && setCountryList(countryList.map(item => item.split('#')[0]));
  }, [])

  /**
   * handling data inserted into the form fields
   */
  const handleSearch = (event, id, type) => {
    if (type === "date") {
      const year = event.$y;
      const month = event.$M < 9 ? "0" + (event.$M + 1) : event.$M + 1;
      const day = event.$D < 10 ? "0" + event.$D : event.$D;

      setSearchData({
        ...searchData,
        [id]: `${year}-${month}-${day}`,
      });

      if (
        id === "startdate" &&
        (searchData.enddate === undefined || searchData.enddate === "")
      ) {
        setMinDate(`${year}/${month}/${day}`);
      } else if (
        id === "enddate" &&
        (searchData.startdate === undefined || searchData.startdate === "")
      ) {
        setMaxDate(`${year}/${month}/${day}`);
      }
    } else {
      setSearchData({ ...searchData, [event.target.name]: event.target.value });
    }
  };

  /**
   * handling card collapse
   */
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  /**
   * clear all data from form fields
   */
  const clearAll = () => {
    setSearchData("");
    setMinDate("");
    setMaxDate("");
  };

  /**
   * function for searching data using filters
   */
  const searchOption = () => {
    if (searchData !== undefined && Object.keys(searchData).length > 0) {
      props.searchItem(searchData);
    } else {
      props.openPopup();
    }
  };

  /**
   * reset and view recent records
   */
  const resetAndViewRecords = () => {
    clearAll()
    props.searchItem();
  };

  return (
    <Card
      style={{
        cursor: "pointer",
        height: "auto",
        maxHeight: "auto",
        border: "1px solid grey",
        minWidth: "50%",
        margin: "auto",
        maxWidth: "90%",
      }}
      className="_wg-dynamic-text"
    >
      <CardActions disableSpacing className="p-0">
        <CardHeader
          subheader={
            <Typography variant="div" style={{ fontSize: "20px", fontWeight: `${expanded ? "bold" : "normal"}` }}>
              Advanced Search
            </Typography>
          }
        />

        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <Tooltip
            disableFocusListener
            title={expanded ? "Collapse" : "Open"}
            id="tooltip"
          >
            <ExpandMoreIcon />
          </Tooltip>
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent
          sx={{ flex: "1 0 auto", fontSize: "15px", margin: "auto" }}
        >
          <Grid container spacing={3}>
            <Grid item md={3} sm={6} xs={6}>
              <DateTranslatedPicker
                id="startdate"
                label='Start Date'
                maxDate={maxDate}
                name='startDate'
                value={searchData && searchData['startDate'] ? (searchData['startDate']) : null}
                handleSearch={(event, name, type) => handleSearch(event, name, type)}
                className='admin-tracker-input'
              />
            </Grid>

            <Grid item md={3} sm={6} xs={6}>
              <DateTranslatedPicker
                id="enddate"
                label='End Date'
                maxDate={maxDate}
                minDate={minDate}
                name='endDate'
                value={searchData && searchData['endDate'] ? (searchData['endDate']) : null}
                handleSearch={(event, name, type) => handleSearch(event, name, type)}
                className='admin-tracker-input'
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <TextField
                fullWidth
                id="userId"
                label="User Id"
                variant="outlined"
                size="small"
                name="userId"
                value={searchData.userId || ""}
                onChange={handleSearch}
                className="admin-tracker-input"
              />
            </Grid>

            <Grid item md={3} sm={6} xs={12}>
              <TextField
                fullWidth
                id="admin-tracker-input"
                label="User Email Id"
                variant="outlined"
                size="small"
                type="email"
                value={searchData.userEmail || ""}
                name="userEmail"
                onChange={handleSearch}
                className="admin-tracker-input"
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <TextField
                fullWidth
                id="requestId"
                label="Request Id"
                variant="outlined"
                size="small"
                value={searchData.requestId || ""}
                name="requestId"
                onChange={handleSearch}
                className="admin-tracker-input"
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FormControl fullWidth className='_wg-dynamic-text' size='small'>
                <InputLabel id='dcr-action'>Status</InputLabel>
                <Select
                  labelId='dcr-action'
                  id='action'
                  value={searchData ? searchData['status'] || '' : ''}
                  label='Status'
                  name='status'
                  onChange={handleSearch}
                  className='_wg-dynamic-text'
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: '200px',
                        width: 'auto',
                      },
                    },
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                  }}
                >
                  <MenuItem className='_wg-dynamic-text' value=''>
                    <em>All</em>
                  </MenuItem>
                  {
                    jsondata.StatusList.sort().map((status, index) => (
                      <MenuItem className='_wg-dynamic-text' key={index} value={status}>{status}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>

            {
              countryList && <Grid item md={4} sm={6} xs={12}>
                <FormControl fullWidth className='_wg-dynamic-text' size='small'>
                  <InputLabel id='dcr-action'>Country</InputLabel>
                  <Select
                    labelId='dcr-action'
                    id='action'
                    value={searchData ? searchData['country'] || '' : ''}
                    label='Country'
                    name='country'
                    onChange={handleSearch}
                    className='_wg-dynamic-text'
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: '200px',
                          width: 'auto',
                        },
                      },
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                    }}


                  >
                    <MenuItem className='_wg-dynamic-text' value=''>
                      <em>All</em>
                    </MenuItem>
                    {countryList.filter((item, index) => countryList.indexOf(item) === index)
                      .map((country, index) => (
                        <MenuItem className='_wg-dynamic-text' key={index} value={country}>{country}</MenuItem>))}
                  </Select>
                </FormControl>
              </Grid>
            }

            <Grid item md={6} sm={6} xs={12}>
              <FormControl fullWidth className=' _wg-dynamic-text' size='small'>
                <InputLabel id='dcr-action'>DCR Source</InputLabel>
                <Select
                  labelId='dcr-action'
                  id='action'
                  value={searchData ? searchData['requestFrom'] || '' : ''}
                  label='DCR Source'
                  name='requestFrom'
                  onChange={handleSearch}
                  className='_wg-dynamic-text'
                >
                  <MenuItem className='_wg-dynamic-text' value=''>
                    <em>All</em>
                  </MenuItem>
                  <MenuItem className='_wg-dynamic-text' value={'ECS'}>ECS</MenuItem>
                  <MenuItem className='_wg-dynamic-text' value={'CRM'}>CRM</MenuItem>
                  <MenuItem className='_wg-dynamic-text' value={'Consumer'}>Consumer</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <FormControl fullWidth className='_wg-dynamic-text' size='small'>
                <InputLabel id='dcr-action'>Managed By</InputLabel>
                <Select
                  labelId='dcr-action'
                  id='action'
                  value={searchData ? searchData['managedBy'] || '' : ''}
                  label='Managed By'
                  name='managedBy'
                  onChange={handleSearch}
                  className='_wg-dynamic-text'
                >
                  <MenuItem className='_wg-dynamic-text' value=''>
                    <em>All</em>
                  </MenuItem>
                  {
                    jsondata.ManagedBy.sort((a, b) => a.label.localeCompare(b.label)).map((item, index) => (
                      <MenuItem className='_wg-dynamic-text' key={index} value={item.value}>{item.label}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>


            <Grid item md={5} sm={5} xs={5} style={{ textAlign: "left" }}>
              <Tooltip
                disableFocusListener
                title="Clear and reset to see the most recent 100 records."
                id="tooltip"
              >
                <Button
                  className="btn btn-secondry border request"
                  id="mergeButton"
                  onClick={() => resetAndViewRecords()}
                >
                  Clear and Reset Results
                </Button>
              </Tooltip>
            </Grid>

            <Grid style={{ textAlign: "right" }} item md={7} sm={7} xs={7}>
              <Button
                className="btn btn-secondry border clearall"
                id="mergeButton"
                onClick={() => clearAll()}
              >
                Clear Filter
              </Button>

              <Button
                className="btn btn-secondry border request nextButton ml-3"
                id="mergeButton"
                onClick={() => searchOption()}
              >
                Search
              </Button>
            </Grid>
          </Grid>

          <div className="d-flex justify-content-cente mt-3">
            <Typography className="text-muted admin-tracker-input">
              Note: The records shown below include the most recent 100 entries. To view additional records, kindly click the "Load More" button at the end of the list.
              For a more tailored result, please make use of the filters provided above.
            </Typography>
          </div>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default FilterOption;
